import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';

import parse from 'html-react-parser';

import {CadastroSimples} from '../../data/interfaces';
import * as images from '../../images/images';
import * as api from '../../services/firebase';
import {Container, Imagem, Titulo, Texto, Mensagem} from './styles';

export default function Informativo() {
  const [informacao, setInformacao] = useState<CadastroSimples>();
  const {tipo} = useParams();

  useEffect(() => {
    if (tipo) {
      api.getInformativo(tipo, (cadastro: CadastroSimples) => {
        setInformacao(cadastro);
      });
    }
  }, [tipo]);

  return (
    <Container>
      {/* <Imagem src={images.imgVitamina} alt="foto" /> */}
      <Imagem src={informacao?.urlImage} alt="foto" />
      <Titulo>{tipo}</Titulo>
      <Texto>
        {informacao ? parse(informacao?.texto) : <Mensagem>Sem dados</Mensagem>}
      </Texto>
    </Container>
  );
}
